<template>
  <div>
    <div v-if="anyUserOrganizationsAvailable">
      <v-card
        v-for="(item, index) in userOrganizations"
        :key="index"
        color="white"
        elevation="0"
        class="container"
      >
        <div class="details-container mb-3">
          <v-card-text>
            <p class="title-text-style">
              Organization:
              <font class="value-text-style">
                {{ item.organization.name }}
              </font>
            </p>
            <p class="title-text-style">
              Company:
              <font class="value-text-style">
                {{ item.company.name }}
              </font>
            </p>
            <p class="title-text-style">
              Role:
              <font class="value-text-style">
                {{ item.app_user_role | formatRole }}
              </font>
            </p>
            <p class="title-text-style">
              Check-in Type:
              <font class="title-text-style type-style">
                {{ item.types | arrangePretty }}
              </font>
            </p>
          </v-card-text>
        </div>
      </v-card>
    </div>
    <div
      v-else
      class="empty-alert-div"
    >
      <v-card
        color="#FFF"
        elevation="0"
      >
        <br>
        <br>
        <br>
        <p class="empty-alert-msg">
          <v-icon
            size="25"
            color="#C62828"
          >
            mdi-information-outline
          </v-icon>
          No Organizations found
        </p>
        <br>
        <br>
      </v-card>
    </div>
    <centre-spinner :loading="loading" />
  </div>
</template>

<script>
import spinner from 'src/views/components/SpinnerCentre';
export default {
  name: 'UserOrganizations',
  components: {
    'centre-spinner': spinner,
  },
  filters: {
    capitalizeFirstLetter (string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    arrangePretty (val) {
      if (Array.isArray(val)) {
        return val
          .map((type) => (type === 'staff' ? 'Site Manager' : type))
          .join(', ');
      }
      return val;
    },
    formatRole (val) {
      if (val === 'site-manager') {
        return 'Site Manager';
      } else if (val === 'contractor') {
        return 'Contractor';
      } else {
        return 'Worker';
      }
    },
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    userOrganizations () {
      return this.$store.getters['organization/getUserOrganizations'];
    },
    anyUserOrganizationsAvailable () {
      if (this.userOrganizations.length !== 0) {
        return true;
      }
      return false;
    },
  },
  async mounted () {
    this.loading = true;
    await this.getUserOrganizations();
    this.loading = false;
  },
  methods: {
    async getUserOrganizations () {
      this.loading = true;
      await this.$store.dispatch('organization/fetchUserOrganizations', {
        params: {
          requestStatus: 'accepted',
        },
      });
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.v-card.container {
  border-radius: 10px !important;
  padding: 0px !important;
}

p {
  margin-bottom: 0px;
}

.center-items {
  display: flex;
  align-items: center;
  justify-content: center;
}
.sub-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.details-container {
  width: 100% !important;
  border-radius: 10px;
}
.type-style {
  color: #ff3700;
  text-transform: capitalize;
}
.v-card {
  padding: 0px !important;
}
</style>
